// @core/api/endpoints/userprofile/get_userprofile_active.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetUserprofileActiveResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Get active profile status
 * Returns the activation status of a profile, indicating whether it is currently active and usable or has been deactivated.
 */
export async function GetUserprofileActive(
  profile_id: string,
  options?: RequestOptions
): Promise<GetUserprofileActiveResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/active`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.get<GetUserprofileActiveResponse>(requestPath, { ...requestOptions });
}
